module.exports = __webpack_public_path__ + "static/media/dashboard-icon.7f5d1a7a.svg";